import { DataTable } from "../../../components/DataTable.tsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaEye,
  FaPencilAlt,
  FaExclamationTriangle,
  FaTrashAlt,
  FaPlus,
} from "react-icons/fa";
import { Button } from "../../../components/ui/button";
import Modal from "../../../components/Modal";
import { communityService, dashboardService } from "../../../services";
import { Skeleton } from "../../../components/ui/skeleton";
import { toast } from "react-toastify";
import useUserStore from "../../../stores/userStore.js";
import { GoLog } from "react-icons/go";
import { GrGroup } from "react-icons/gr";
import TableCard from "../../../components/TableCard";
import LoadingImage from "../../../components/LoadingImage.js";
import { createItemStore } from "../../../stores/createItemStore";
import useUserStore2 from "../../../stores/userStore2.js";
import StatusBadge from "../../../components/table/StatusBadge"

const columns = [
  // {
  //   accessorKey: "communityId",
  //   header: "Community ID",
  //   cell: ({ row }) => (
  //     <span>
  //       <ShortenedText text={row.getValue("communityId")} />
  //     </span>
  //   ),
  // },
  {
    accessorKey: "communityName",
    header: "Community Name",
    cell: ({ row }) => <span>{row.getValue("communityName")}</span>,
  },
  {
    accessorKey: "adminProfile",
    header: "Admin Name",
    cell: ({ row }) => <span>{row.getValue("adminProfile")}</span>,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <StatusBadge status={status} />
      );
    },
  },
  {
    accessorKey: "address",
    header: "Address",
    cell: ({ row }) => <span>{row.getValue("address")}</span>,
  },
  {
    accessorKey: "city",
    header: "City",
    cell: ({ row }) => <span>{row.getValue("city")}</span>,
  },
];

// ========================================================
// Step 1: Zustand store instantiation
// ========================================================
const dataMap = (item) => ({
  communityId: item._id, // Mapping _id to communityId
  communityName: item.name, // Mapping name to communityName
  adminId:
    item.admins.length > 0
      ? item.admins.map((admin) => admin.profile?._id || "Unknown").join(", ")
      : "N/A", // Extracting profile ID, handling missing profile field
  status: item.status === "A" ? "Active" : "Dormant", // Converting status
  adminProfile:
    item.admins.length > 0
      ? item.admins.map((admin) => admin.profile?.name || "Unknown").join(", ")
      : "N/A", // Extracting profile NAME, handling missing profile field
  address: `${item.address_line1}${
    item.address_line2 ? `, ${item.address_line2}` : ""
  }`, // Handling null address_line2
  city: item.city, // Keeping city as is
});

const storeName = "communities";
const useItems = createItemStore(
  storeName,
  (community) => community.communityId,
  communityService.getCommunity,
  dataMap
);
// ========================================================

export default function CommunityManagementPage() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [communityIdToSuspend, setCommunityIdToSuspend] = useState(null);
  const [communityIdToActivate, setCommunityIdToActivate] = useState(null);
  const [communityIdToDelete, setCommunityIdToDelete] = useState(null);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pendingRequests, setPendingRequests] = useState({
    total: 0,
    oldTotal: 0,
  });
  const [isPendingRequestsLoading, setIsPendingRequestsLoading] =
    useState(true);
  const { user } = useUserStore2();

  console.log("user.id: ", user?.id);
  const userId = user?.id;

  const suspendCommunity = async (communityId) => {
    try {
      setLoading(true);
      const communityData = {
        EntityId: userId, // Set the EntityId from the store
        CommunityId: communityId,
        Status: "D", // Set the status to "Suspended"
      };

      const result = await communityService.editCommunityDetails(communityData);
      fetchItems();
      console.log("Community Deactivated successfully:", result);
      toast.success("🎉 Community Deactivated successfully!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Failed to Deactivate community:", error);
      toast.error("❌ Failed to Deactivate community", { autoClose: 2000 });
    } finally {
      setLoading(false);
      setReload((prev) => !prev);
    }
  };

  const handleConfirmSuspend = async () => {
    if (communityIdToSuspend) {
      await suspendCommunity(communityIdToSuspend); // Call suspendCommunity
      setIsOpen(false); // Close the modal after confirming
      fetchItems();
    }
  };

  const activateCommunity = async (communityId) => {
    try {
      setLoading(true);
      const communityData = {
        EntityId: userId, // Set the EntityId from the store
        CommunityId: communityId,
        Status: "A", // Set the status to "Suspended"
      };

      const result = await communityService.editCommunityDetails(communityData);
      console.log("Community Activated successfully:", result);
      toast.success("🎉 Community Activated successfully!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Failed to Activate community:", error);
      toast.error("❌ Failed to Activate community", { autoClose: 2000 });
    } finally {
      setLoading(false);
      setReload((prev) => !prev);
    }
  };

  const handleConfirmActivate = async () => {
    if (communityIdToActivate) {
      await activateCommunity(communityIdToActivate); // Call suspendCommunity
      setIsActivateOpen(false); // Close the modal after confirming
      fetchItems();
    }
  };

  const handleConfirmDelete = async () => {
    if (communityIdToDelete) {
      try {
        setLoading(true);
        // Call the removeCommunity function
        await communityService.removeCommunity(communityIdToDelete);
        toast.success("🎉 Community deleted successfully!", {
          autoClose: 2000,
        });

        // Close the modal and reset the state
        setShowDeleteModal(false);

        setReload((prev) => !prev);
        fetchItems();
      } catch (error) {
        console.error("Failed to delete community:", error);
        toast.error("❌ Failed to delete community", { autoClose: 2000 });
      } finally {
        setLoading(false);
      }
    }
  };

  const actions = (row) => {
    const baseActions = [
      {
        label: "View Details",
        icon: <FaEye />,
        onClick: () => navigate(`/communities/view/${row.communityId}`),
        variant: "dropPlain",
      },
      {
        label: "Edit Community",
        icon: <FaPencilAlt />,
        onClick: () => navigate(`/communities/edit/${row.communityId}`),
        variant: "dropPlain",
      },
    ];

    // Add activate/deactivate action based on status
    if (row.status === "Dormant") {
      baseActions.push({
        label: "Activate Community",
        icon: <FaExclamationTriangle />,
        onClick: () => {
          setCommunityIdToActivate(row.communityId);
          setIsActivateOpen(true);
        },
        variant: "dropGreen",
      });
    } else if (row.status === "Active") {
      baseActions.push({
        label: "Deactivate Community",
        icon: <FaExclamationTriangle />,
        onClick: () => {
          setCommunityIdToSuspend(row.communityId);
          setIsOpen(true);
        },
        variant: "dropRed",
      });
    }

    return baseActions;
  };

  // ========================================================
  // Step 2: Zustand store and page hydration
  // ========================================================
  const { isLoading, fetchItems, getSortedFiltered } = useItems(
    (state) => state
  );
  const data = getSortedFiltered();
  const showLoading = data.length === 0 && isLoading;
  // console.log(`${storeName}:`, data);
  useEffect(() => {
    fetchItems();
  }, []);
  // ========================================================

  const totalCommunitites = data?.length || 0;

  // Update the pending requests useEffect
  useEffect(() => {
    const fetchPendingRequests = async () => {
      if (!user?.id) {
        setIsPendingRequestsLoading(true);
        return;
      }

      try {
        setIsPendingRequestsLoading(true);
        const response = await dashboardService.countTotalPendingRequests(
          user.id
        );
        setPendingRequests({
          total: response.total_pending_requests,
          oldTotal: response.total_pending_requests_old,
        });
      } catch (error) {
        console.error("Error fetching pending requests:", error);
        // Optionally set some error state here
      } finally {
        setIsPendingRequestsLoading(false);
      }
    };

    fetchPendingRequests();
  }, [reload, user?.id]);

  return (
    <div className="flex flex-col md:flex-row min-h-screen ">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 p-4 sm:p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
            {/* Total Communities - With Skeleton */}
            {showLoading ? (
              // {getCommunity.loading ? (
              <Skeleton className="w-full h-32 rounded-xl" />
            ) : (
              <TableCard
                heading="Total Communitites"
                number={totalCommunitites}
                trend={{ percentage: "20%", isUp: true }}
                bgColor="from-indigo-50 to-indigo-500"
                icon={GrGroup}
                iconColor="text-indigo-500"
                borderColor="border-l-indigo-500"
              />
            )}

            {/* Pending requests - With Skeleton */}
            {isPendingRequestsLoading || showLoading ? (
              <Skeleton className="w-full h-32 rounded-xl" />
            ) : (
              <TableCard
                heading="Pending Requests"
                number={pendingRequests.total}
                trend={{
                  percentage: `${Math.abs(
                    ((pendingRequests.total - pendingRequests.oldTotal) /
                      (pendingRequests.oldTotal || 1)) *
                      100
                  ).toFixed(0)}%`,
                  isUp: pendingRequests.total > pendingRequests.oldTotal,
                }}
                bgColor="from-orange-50 to-orange-300"
                icon={GoLog}
                iconColor="text-yellow-400"
                buttonText="View More"
                buttonLink="/pending-requests"
                borderColor="border-l-yellow-400"
              />
            )}
          </div>

          <div className="bg-white shadow col-span-1 md:max-w-[calc(100vw-375px)] rounded-lg p-4 sm:p-6 text-sm md:mt-0 w-full">
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
              <div className="text-base sm:text-lg font-semibold text-[#111827] mb-4 sm:mb-0">
                Community List
              </div>
              <div className="flex space-x-4">
                <Button onClick={() => navigate("/communities/add")}>
                  <FaPlus /> Create New
                </Button>
              </div>
            </div>
            <hr />

            <div className="overflow-x-auto w-full md:max-w-[calc(100vw-375px)]">
              {showLoading ? (
                // {getCommunity.loading ? (
                <LoadingImage />
              ) : data.length > 0 ? (
                // ) : getCommunity?.data.length > 0 ? (
                <DataTable
                  columns={columns}
                  // data={getCommunity?.data}
                  data={data}
                  actions={actions}
                />
              ) : (
                <div className="text-center text-gray-500 py-6">
                  No requests found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Activate Modal */}
      <Modal
        isOpen={isActivateOpen}
        onClose={() => setIsActivateOpen(false)}
        title="Activate Community"
        description="Are you sure you want to activate this community?"
        icon={<FaExclamationTriangle className="text-green-500" />}
        iconColor="green"
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant={"secondary"}
              onClick={() => setIsActivateOpen(false)}
            >
              Cancel
            </Button>
            <Button onClick={handleConfirmActivate} disabled={loading}>
              {loading ? "Activating..." : "Activate"}
            </Button>
          </div>
        }
      ></Modal>

      {/* Deactivate Modal */}
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Deactivate Community"
        description="Are you sure you want to Deactivate this community?"
        icon={<FaExclamationTriangle className="text-red-500" />}
        iconColor="red"
        actions={
          <div className="flex justify-between w-full">
            <Button variant={"secondary"} onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button
              variant={"destructive"}
              onClick={handleConfirmSuspend}
              disabled={loading}
            >
              {loading ? "Deactivating..." : "Deactivate"}
            </Button>
          </div>
        }
      ></Modal>

      {/* Delete Modal */}
      <Modal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="Delete Community"
        description="Are you sure you want to delete this community? This action is NOT reversible and will result in permanent loss."
        icon={<FaTrashAlt className="text-red-500" />}
        iconColor="red"
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant={"secondary"}
              onClick={() => setShowDeleteModal(false)}
            >
              No, Cancel
            </Button>
            <Button
              variant={"destructive"}
              onClick={handleConfirmDelete}
              disabled={loading}
            >
              {loading ? "Deleting" : "Yes, Delete this Community"}
            </Button>
          </div>
        }
      />
    </div>
  );
}
